<div class="status" [ngClass]="status">
  <p>
    {{ status }}
  </p>
</div>
